import React from "react";

const TagType = ({ row }) => {
  return <div>{row?.tag?.tagType}</div>;
};

export default TagType;
